import { render, staticRenderFns } from "./news_type.vue?vue&type=template&id=15be20ea&scoped=true&"
import script from "./news_type.vue?vue&type=script&lang=js&"
export * from "./news_type.vue?vue&type=script&lang=js&"
import style0 from "./news_type.vue?vue&type=style&index=0&id=15be20ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15be20ea",
  null
  
)

export default component.exports